import { msg } from '@/shared/i18n/msg';
import type { Priority } from './priority';

export const PRIORITY_LABELS: Readonly<Record<Priority, string>> = {
  high: msg('High'),
  medium: msg('Medium'),
  low: msg('Low'),
};
